export default __webpack_public_path__ + "static/media/chat2.cb65d1a7.png";